// frontend/src/components/common/HoursField.js
// Shared "Estimated/Actual Hours" input -- always HH:MM (spec: "00:00"
// format), used by TicketForm and StatusFlowPanel. Storage stays decimal;
// convert with parseHours()/fmtHours() (parts/PartForm.js, constants/domain.js).
import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

const HHMM_RE = /^\d{1,3}:[0-5]\d$/;

export const isValidHhMm = (value) => {
    if (value === '' || value === null || value === undefined) return true;
    return HHMM_RE.test(String(value).trim());
};

const HoursField = ({ label, value, onChange, required, error, helperText, disabled, size }) => (
    <TextField
        fullWidth
        size={size}
        label={label}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="00:00"
        error={error}
        helperText={helperText || 'HH:MM, e.g. 08:30'}
        disabled={disabled}
        InputProps={{ endAdornment: <InputAdornment position="end">h</InputAdornment> }}
    />
);

export default HoursField;
